export const getCacheBustedImageUrl = (
  imageUrl?: string,
  lastModified?: string | Date
): string | undefined => {
  if (!imageUrl) return undefined;
  const date = typeof lastModified === 'string' ? new Date(lastModified) : lastModified;
  const timestamp = date?.getTime();
  return timestamp ? `${imageUrl}?t=${timestamp}` : imageUrl;
};
